export const SET_CATEGORY = "PREVIEW_SET_CATEGORY";  
export const SET_ITEMS = "PREVIEW_SET_ITEMS"; 
export const SET_SELECTED = "PREVIEW_SET_SELECTED"; 
export const SET_INDEX_UPDATE_PREVIEW = "SET_INDEX_UPDATE_PREVIEW"; 
export const SET_PREVIEW_POSITION = "PREVIEW_SET_POSITION"; 